import { createContext } from 'react'

import { TournamentIdContextParams } from './Line.types'

//  It is needed for auto-testing purposes

export const TournamentIdContext =
  createContext<TournamentIdContextParams | null>(null)
